import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { noop } from '../../../lib/utils';
import EmergencyStatusPropType from '../../prop-types/emergency-status';
import SocialShareModal from '../SocialShareModal';

export default function OutageSocialShare({ url, status, includeDiesel: sellsDiesel, onComplete }) {
  const { t } = useTranslation('station');

  const link = url || window.location.href;
  const hasPower = !status.hasPower || (status.hasPower && status.hasPower.reportStatus);
  const hasGas = !status.hasGas || (status.hasGas && status.hasGas.reportStatus);
  const hasDiesel = !status.hasDiesel || (status.hasDiesel && status.hasDiesel.reportStatus);
  let message;

  // If gas, diesel, and power - GasBuddy reports this station as being fully operational.
  // If gas and power, no diesel- GasBuddy reports this station as having gas, but no diesel.
  // If diesel and power, no gas - GasBuddy reports this station as having diesel, but no gas.
  // If power, no gas and no diesel - GasBuddy reports this station as having power, but no fuel.
  // If out of everything, or no power- GasBuddy reports this station as being out-of-service.
  if (hasPower && hasGas && ((sellsDiesel && hasDiesel) || !sellsDiesel)) {
    message = t('outage.fullyOperationalReport', { ns: 'station' });
  } else if (hasPower && hasGas && sellsDiesel && !hasDiesel) {
    message = t('outage.hasGasNoDieselReport', { ns: 'station' });
  } else if (hasPower && !hasGas && sellsDiesel && hasDiesel) {
    message = t('outage.hasDieselNoGasReport', { ns: 'station' });
  } else if (hasPower && !hasGas && (!sellsDiesel || (sellsDiesel && !hasDiesel))) {
    message = t('outage.hasPowerNoFuelReport', { ns: 'station' });
  } else if (!hasPower) {
    message = t('outage.noPowerReport', { ns: 'station' });
  } else {
    throw new Error(t('outage.invalidStationStatus', { ns: 'station' }));
  }

  return (
    <SocialShareModal
      title={t('outage.shareStationStatus', { ns: 'station' })}
      message={t('outage.socialShareMessage', { ns: 'station' })}
      emailParams={{
        subject: message,
        body: `${message}\n\n${link}`,
      }}
      twitterParams={{
        url: link,
        text: message,
      }}
      onShare={onComplete}
    />
  );
}

OutageSocialShare.propTypes = {
  url: PropTypes.string,
  status: EmergencyStatusPropType,
  includeDiesel: PropTypes.bool,
  onComplete: PropTypes.func,
};

OutageSocialShare.defaultProps = {
  url: undefined,
  status: {},
  includeDiesel: false,
  onComplete: noop,
};
